import { useCoreService } from 'core/services/useCoreService';
import { CardsTotals } from 'core/tarjeta/models/CardsTotals';
import { Periodo } from 'shared/models/Periodo';
import { withPagination } from 'shared/table/hoc/withPagination';
import { Pageable } from 'shared/table/models/Pageable';
import { CardsTotalsTable } from '../CardsTotalsTable/CardsTotalsTable';

const TableWithPagination = withPagination<CardsTotals>(CardsTotalsTable);

export const CardsTotalsTableWithPagination = (props: {
  numeroCuenta: string;
  totalesPorTarjeta: Pageable<CardsTotals>;
  periodo: Periodo;
}) => {
  const coreService = useCoreService();

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<CardsTotals>> => {
    const response = await coreService.searchCardTotals({
      numeroCuenta: props.numeroCuenta,
      page: status.pageNumber,
      size: status.pageSize,
      mes: props.periodo?.mes,
      anio: props.periodo?.anio,
    });
    return response.body;
  };

  return (
    <TableWithPagination
      pageableInit={props.totalesPorTarjeta}
      periodo={props.periodo}
      dataFetcherFunction={onChangePaginationStatus}
    ></TableWithPagination>
  );
};
